import { DocumentIdentifier } from "../../document";
import { ReceptionApplicant, ReceptionRecipient, ReceptionDelivery, ReceptionContact, ReceptionPatient } from "../reception";
import { ReceptionInputSection } from "../items";
import { InOutKinds } from "../kinds";

// 依頼受付
export class Reception {
  public id: number;
  public patientInfo: ReceptionPatient = new ReceptionPatient();
  public receptionNumber: string;
  public receptionDate: Date = Reception.getToday();  // デフォルト本日
  public inputSection: ReceptionInputSection = new ReceptionInputSection(null, null, false);
  public inOutType: InOutKinds;
  // 医療機関
  public document: DocumentIdentifier;
  public isTemporary: boolean;
  public isMigrated: boolean;
  public applicant: ReceptionApplicant = new ReceptionApplicant();
  public recipient: ReceptionRecipient = new ReceptionRecipient();
  public delivery: ReceptionDelivery = new ReceptionDelivery();
  public contact: ReceptionContact = new ReceptionContact();
  public deleted: boolean;

  private static getToday(): Date {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  clone(): Reception {
    const newObj = new Reception();
    newObj.id = this.id;
    newObj.patientInfo = this.patientInfo.clone();
    newObj.receptionNumber = this.receptionNumber;
    newObj.receptionDate = this.receptionDate;
    newObj.inputSection = this.inputSection;
    newObj.inOutType = this.inOutType;
    newObj.document = this.document;
    newObj.isTemporary = this.isTemporary;
    newObj.applicant = this.applicant.clone();
    newObj.recipient = this.recipient.clone();
    newObj.delivery = this.delivery.clone();
    newObj.contact = this.contact.clone();
    newObj.deleted = this.deleted;

    return newObj;
  }
}
